import usePagedQuery, { PagedQueryArgs } from '../usePagedQuery';
import { ThunderbirdOrdersData } from '../../types/IThunderbirdOrderResponse';

export default function useThunderbirdOrderList(args: PagedQueryArgs) {
  return usePagedQuery<ThunderbirdOrdersData>(
    'thunderbird-order-list',
    'api/thunderbird-orders',
    args,
  );
}
